import React, { Component } from "react";
import i18next from "i18next";
import { connect } from "react-redux";
import swal from "sweetalert";
import { withTranslation} from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import AutorenewIcon from "@material-ui/icons/Autorenew";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { withRouter } from "react-router-dom";
import PersonIcon from "@material-ui/icons/Person";
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import { auth } from "../../service/firebase";
import ThemeSwitcher from "../ThemeSwitcher";
import Services from "../../api/api";
import OffileDb from '../../config/pouchDB';
import imgUrl from '../../assets/images/imageUrl';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InfoIcon from '@material-ui/icons/Info';
import { setLangID, setSelectedComponentObject } from "../../redux/actions/appActions";
import { createStore } from 'redux';
import reducer from '../../redux/reducers/appReducer';
import { gaLogEvent, gaLogScreen } from "../../helpers/analytics";
import { logError} from "../../helpers/auth";
import moment from 'moment';
import DeleteIcon from '@material-ui/icons/Delete';
import { logout, signInAnonymously } from "../../helpers/auth";
const store = createStore(reducer);

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

class Settings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      versionIcon: '',
      open: false,
      collapseflag: false,
      langlist: [],
      defaultVal: 1,
      Russian: "Russian",
      Kyrgyz: "Kyrgyz",
      English: "English",
      userObj: {},
      adminObj: {},
      appversion: "1.0.0",
      tosEnabled: false,
      menuList:
        JSON.parse(localStorage.getItem("menuList")) != null
          ? JSON.parse(localStorage.getItem("menuList"))
          : [],
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.resetApp = this.resetApp.bind(this);
    this.changeTheme = this.changeTheme.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getUserDeatils = this.getUserDeatils.bind(this);
  }

  handleChange = (event) => {
    this.setState({ selected: event.target.value });
    this.getTranslation(event.target.value);
  };

  componentDidMount() {
    gaLogEvent("Settings", '', '');
    OffileDb.setDatabase();
    let userObj = JSON.parse(localStorage.getItem('obj'));
    let adminObj = JSON.parse(localStorage.getItem('adminobj')) != null ? JSON.parse(localStorage.getItem('adminobj')) : {};
    this.setState({ userObj: userObj, adminObj: adminObj, selected: this.props.langId });
    this.getAppVersion()
    if (navigator.onLine) {
      this.getTranslation(this.props.langId);
      var param = {
        communityId: this.props.communityuid,
      };
      Services.getLangList(param).then((res) => {
        try {
          if (res.data.status == 200) {
            this.setState({
              langlist: res.data.data
            });
            OffileDb.setData('langlist', res.data.data)
          }
          this.setState({ isLoading: false });
        } catch (err) {
          console.log("Error::", err);
        }
      });
    }
    var contentList = JSON.parse(localStorage.getItem('contentList'));
    if (contentList.filter(obj => obj.contentId == 74 && obj.isactive).length > 0) {
      this.setState({ tosEnabled: true })
    }
  }

  getTranslation(id) {
    var params = {
      communityId: this.props.communityuid,
      labelType: 'Mobile',
      languageId: id,
    };
    Services.getCommunitywiseLabels(params).then((res) => {
      try {
        if (res.data.status == 200) {
          let lan = res.data.data.locale;
          let tran = res.data.data.label;
          document.getElementsByTagName("body")[0].setAttribute("lag", lan);
          i18next.addResourceBundle(lan, "translations", tran, true, true);
          i18next.changeLanguage(lan);
          localStorage.setItem('langId', id)
          this.props.setLangID(id);
          OffileDb.setData("tranlation", res.data.data)
        }
      } catch (err) {
        console.log("Error::", err);
      }
    });
  }

  ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
  }

  handleClose() {
    this.setState({ open: false });
  }

  handleClickOpen() {
    this.setState({ open: true });
  }

  handleSubmenuClick() {
    this.setState({ collapseflag: !this.state.collapseflag });
  };

  resetApp() {
    this.inactiveUser();
    //localStorage.clear();
    //this.setState({ open: true });
    //this.props.history.push("/");
  }

  onlyResetApp() {
    var currentid = localStorage.getItem("templateID");
    var fcmToken = localStorage.getItem('fcmToken');
    auth().signOut();
    OffileDb.deleteDatabse();
    localStorage.clear();
    localStorage.setItem('langId', this.props.langId);
    localStorage.setItem("templateID", currentid);
    localStorage.setItem('fcmToken', fcmToken);
    // this.props.history.push("/Onboarding");
    const myState = store.getState();
    if (myState.communityId) {
      this.props.history.push("/Onboarding");
    } else {
      this.props.history.push("/CommunityList");
    }
  }

  goToTOS() {
    this.props.history.push("/layout/tos");
  }

  goToUserProfile() {
    this.props.history.push("/layout/UserProfile");
  }
  goToUserLogin() {
    // if(localStorage.getItem('loggedinname')){
    //   this.props.history.push("/layout/loginPin");
    // }else{
    //   this.props.history.push("/layout/userlogin");
    // }
    this.props.history.push("/layout/userlogin");
  }
  goToEmergencyContacts() {
    this.props.history.push("/layout/EmergencyContacts");
  }

  getAppVersion() {
    var param = {
      id: this.props.communityuid,
    };
    Services.getAppVersion(param).then((res) => {
      try {
        this.setState({ appversion: res.data.data.appVersion });
      } catch (err) {
        console.log("Error::", err);
      }
    });
  }

  reloadCommunity() {
    const { t } = this.props;
    swal({
      text: t("Community reloaded successfully"),
      icon: "success",
      button: t("ok"),
    }).then((val) => {
      OffileDb.deleteDatabse();
    });
  }

  inactiveUser() {
    console.log(this.state.userObj);
    var param = {
      communityId: this.props.communityuid,
      isactive: false,
      userId: this.state.userObj.userId,
    };
    var currentid = localStorage.getItem("templateID");
    try {
      Services.inactiveUser(param).then((res) => {
        OffileDb.deleteDatabse();
        localStorage.clear();
        //var tempid = currentid == 1 ? "2" : "1";
        localStorage.setItem("templateID", currentid);
        this.props.history.push("/Onboarding");
      });
    } catch (err) {
      console.log("Error::", err);
    }
  }

  getSettingMenuList(child) {
    var list = [];
    const { t } = this.props;
    child.map((menu) => {
      if ((menu.componentId != 40 || menu.path != "version")) {
        if (menu.componentId != 37 || (this.state.tosEnabled && menu.componentId == 37)) {
          // var spliurtl = menu.icon.split("://")
          // let myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
          let menuicon = this.getMenuIcon(menu)
          list.push(
            <ListItem button onClick={() => this.onSettinglinkClick(menu)}>
              <ListItemIcon>
                {menuicon}
              </ListItemIcon>
              {
                menu.componentId == 40 || menu.path == "version" ? (
                  <ListItemText primary={"V: " + this.state.appversion} />
                ) : menu.componentId == 39 || menu.path == "userlogin" ? (
                  <ListItemText primary={Object.keys(this.state.adminObj).length != 0 ? t('Logout') : t(menu.name)} />
                ) : (
                  <ListItemText primary={t(menu.name)} />
                )
              }
            </ListItem>
          );
        }
      }
    });
    list.push(
      <>
        <ListItem button onClick={() => this.reloadCommunity()}>
          <ListItemIcon>
            <i className="demo-icon icon-reset"></i>
          </ListItemIcon>
          <ListItemText primary={t("Reload data")} />
        </ListItem>
        {/* <ListItem button onClick={() => this.goToEmergencyContacts()}>
          <ListItemIcon>
            <i className="demo-icon icon-sos"></i>
          </ListItemIcon>
          <ListItemText primary={t("SOS Contact")} />
        </ListItem> */}
      </>
    )
    return list;
  }

  getMenuIcon(menu) {
    if (menu.className) {
      return <i className={"demo-icon " + menu.className}></i>
    } else if (menu.icon != "") {
      let myUrl = this.getHttpsUrl(menu.icon)
      return <img className="seetingMenuIcons" src={myUrl} />
    } else {
      return <InfoIcon />
    }
  }

  getHttpsUrl(iconurl) {
    var spliurtl = iconurl.split("://")
    let myUrl = null;
    if(spliurtl){
      myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
    }
    return myUrl;
  }



  onSettinglinkClick(menu) {
    if (menu.componentId == 36 || menu.path == "reset") {
      this.onlyResetApp()
    } else if (menu.componentId == 37 || menu.path == "tos") {
      this.goToTOS()
    } else if (menu.componentId == 38 || menu.path == "userprofile") {
      this.goToUserProfile()
    } else if (menu.componentId == 39 || menu.path == "userlogin") {
      if (Object.keys(this.state.adminObj) && Object.keys(this.state.adminObj).length != 0) {
        this.handleAdminLogout()
      } else {
        this.goToUserLogin()
      }
    }
  }

  handleAdminLogout() {
    var self = this;
    OffileDb.deleteDatabse();
    setTimeout(function () {
      try{
        localStorage.removeItem('adminobj')
        self.setState({ adminObj: {} });
        localStorage.setItem('obj', localStorage.getItem('tempuserobj'))
        self.getUserDeatils(JSON.parse(localStorage.getItem("tempuserobj")).userId)
        localStorage.removeItem('tempuserobj')
        localStorage.removeItem('adminobj')
        //self.props.history.push("/layout");
        logout(); // logout from firebase
      }catch(err){
        console.log("err::", err);
      }
    }, 500);
  }

  getUserDeatils(userId) {
    var param = {
      "communityId": this.props.communityuid,
      "userId": userId
    }
    Services.getUserProfile(param).then((res) => {
      if (res.status == 200) {
        if(res.data.data.profile && res.data.data.profile.nickName){
          signInAnonymously().then((s) => {
            auth().onAuthStateChanged((user) => {
              if (user) {
                user.updateProfile({
                  displayName: res.data.data.profile.nickName,
                }).then(function (s) {
                    console.log("updateProfile res>>", s);
                  }).catch(function (error) {
                    console.log("updateProfile error>>", error);
                  });
              }
            });
          }).catch((err) => console.log("err>>>", err));
        }
      }
      this.props.history.push("/layout");
    });
  }


  changeTheme(id) {
    localStorage.setItem("templateID", 2);
    //this.props.history.push("/layout2");
    window.location.reload();
  }

  render() {
    const { t } = this.props;
    const { templateID } = this.props;
    var menulist = this.state.menuList.filter(
      (obj) => obj.componentId == 35 || obj.path == "settings"
    );
    if (menulist && menulist.length > 0) {
      var list = this.getSettingMenuList(menulist[0].childs);
    }

    let listforlanguage = this.state.langlist;
    let value = parseInt(this.state.selected);
    return (
      <div className="gk-page getknowledgeable_page">
        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>
            </div>
          )
        }
        <div className="gridcontainer text-center getknowledgepagemaindiv">
          <List component="nav" className="settingmenulist" aria-label="main mailbox folders">
            {menulist && menulist.length > 0 ? (
              list
            ) : (
              <div>
                <ListItem button onClick={() => this.handleClickOpen()}>
                  <ListItemIcon>
                    <AutorenewIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("Reset")} />
                </ListItem>
                <ListItem button onClick={() => this.goToTOS()}>
                  <ListItemIcon>
                    <AssignmentTurnedInIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("Terms And Condition")} />
                </ListItem>
                <ListItem button onClick={() => this.goToUserProfile()}>
                  <ListItemIcon>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("user Profile")} />
                </ListItem>
                {Object.keys(this.state.adminObj).length != 0 ? (
                  <ListItem button onClick={() => this.handleAdminLogout()}>
                    <ListItemIcon>
                      <PersonIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("Logout")} />
                  </ListItem>
                ) : (
                  <ListItem button onClick={() => this.goToUserLogin()}>
                    <ListItemIcon>
                      <PersonIcon />
                    </ListItemIcon>
                    <ListItemText primary={t('User Login')} />
                  </ListItem>)
                }

              </div>
            )

            }
            <div>
              <ListItem button onClick={() => this.handleSubmenuClick()}>
                <ListItemIcon>
                  <i className="demo-icon icon-language"></i>
                </ListItemIcon>
                <ListItemText primary={t('Change language')} />
                {this.state.collapseflag ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={this.state.collapseflag} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItem button>
                    <FormControl component="fieldset" key="1">
                      <RadioGroup name="gender1" value={value} >
                        {listforlanguage.length > 0 && listforlanguage.map((name) => (
                          <FormControlLabel
                            className="animate__animated animate__zoomIn animate__faster"
                            key={name.languageId}
                            value={name.languageId}
                            control={<Radio />}
                            label={name.languageName}
                            onChange={this.handleChange}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                  </ListItem>
                </List>
              </Collapse>
            </div>
            <ThemeSwitcher chnageTheme={templateID} showcontent={true}></ThemeSwitcher>
            <ListItem button >
              <ListItemIcon>
                <DesktopWindowsIcon />
              </ListItemIcon>
              <ListItemText primary={"V: " + this.state.appversion} />
            </ListItem>

          </List>
          {templateID == 2 && <Divider />}
          <div className="text-center ml-15px mr-15px">
            <img className="settingpageimag poweredbyimg hide" src={imgUrl.poweredby} />
            <p className="text-center mb-0 mt-0 powertext">Powered by Dure Technologies</p>
          </div>


          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <div>
                  {t("Are you sure you want to reset from the application?")}
                </div>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                {t("no")}
              </Button>
              <Button color="primary" autoFocus onClick={() => this.resetApp()}>
                {t("yes")}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    selectedComponentObj: {},
  };
};

// const ThemeKnowYourRights = withTheme(KnowYourRights);
// const FinalThemeKnowYourRights = withStyles(useStyles)(ThemeKnowYourRights);
const transSettings = withTranslation()(Settings);
const routeSettings = withRouter(transSettings);
export default connect(mapStateToProps, { setLangID, setSelectedComponentObject })(routeSettings);
